import { Injectable } from '@angular/core';
@Injectable({
    providedIn: 'root'
  })
export class servicesUrl {
   public url = 'https://api2.wcrg.org:444/our_team/getPost';
   public imgUrl= 'https://api2.wcrg.org:444/images/post/';
}
